var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 5.25H3.75C2.50736 5.25 1.5 6.25736 1.5 7.5V16.5C1.5 17.7426 2.50736 18.75 3.75 18.75H20.25C21.4926 18.75 22.5 17.7426 22.5 16.5V7.5C22.5 6.25736 21.4926 5.25 20.25 5.25Z",
    fill: "#0F70CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2699 6.75L19.7306 8.22375L19.1996 6.75H16.2859V8.6865L15.4339 6.75H13.0946L10.6504 12.3068H12.6281V17.25H18.7009L19.6879 16.1565L20.6794 17.25H22.3624C22.4464 17.0145 22.5004 16.7647 22.5004 16.5V15.7192L21.3154 14.4457L22.5004 13.2045V7.5C22.5004 7.23525 22.4464 6.9855 22.3624 6.75H20.2699Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2593 10.8247H15.2168L15.5933 11.6857H16.9283L15.03 7.37024H13.5008L11.6025 11.6857H12.903L13.2608 10.8247H13.2593ZM14.2395 8.47349L14.8208 9.85649H13.6695L14.2395 8.47349Z",
    fill: "#0F70CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9062 7.37024H18.7632L19.7263 10.0425L20.7028 7.37024H22.4998V11.6857H21.3373V8.70224L20.2325 11.6857H19.2057L18.0928 8.72324V11.6857H16.9062V7.37024Z",
    fill: "#0F70CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.43 15.615V14.958H16.863V13.968H14.43V13.311H16.9238V12.3068H13.248V16.6298H16.9238V15.615H14.43Z",
    fill: "#0F70CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4781 12.3068L19.7028 13.6755L20.9756 12.3068H22.4996L20.4618 14.4405L22.4996 16.6298H20.9538L19.6863 15.2318L18.4248 16.6298H16.9023L18.9536 14.4563L16.9023 12.3068H18.4781Z",
    fill: "#0F70CE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M20.25 5.25H3.75C2.50725 5.25 1.5 6.25725 1.5 7.5V16.5C1.5 17.7428 2.50725 18.75 3.75 18.75H20.25C21.4928 18.75 22.5 17.7428 22.5 16.5V7.5C22.5 6.25725 21.4928 5.25 20.25 5.25ZM21.75 16.5C21.75 17.3273 21.0772 18 20.25 18H3.75C2.92275 18 2.25 17.3273 2.25 16.5V7.5C2.25 6.67275 2.92275 6 3.75 6H20.25C21.0772 6 21.75 6.67275 21.75 7.5V16.5Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.25 6H3.75C2.92125 6 2.25 6.67125 2.25 7.5V8.25C2.25 7.42125 2.92125 6.75 3.75 6.75H20.25C21.0788 6.75 21.75 7.42125 21.75 8.25V7.5C21.75 6.67125 21.0788 6 20.25 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAmex);
export default __webpack_public_path__ + "static/media/card-amex.d59161d766b2ba90de3331aa33358412.svg";
export { ForwardRef as ReactComponent };